export const STAY = 'STAY'
export const FLY = 'FLY'
export const DRIVE = 'DRIVE'

export const CALENDAR_POPOVER_SELECTOR = '[aria-label="Calendar navigation tooltip"]'
